export default "__VITE_ASSET__B3wv2N2f__"